module.exports = __webpack_public_path__ + "img/组 295@2x.b5f5d1da.png";